export default {"gitHash":"43c391f8f472613220c33e8d50f950845ac294dd","gitHashShort":"43c391f","time":1678850464933,"platform":"linux","arch":"x64"};